export default function access(user?: API.CurrentUser | null) {
  const isAdmin = user && user.access === 'admin';
  const isDepartmentManager = user && user.access === 'ebsprogramyonet' && user.programId !== 6518;
  const isUnitManager = user && user.access === 'altbirimyoneticisi';
  const isStudent = user && user.access === 'student';
  const isInternationalOfficeUser = user && user.access === 'ebsprogramyonet' && user.programId === 6518;

  const canAccessAdmin =
    isAdmin ||
    isDepartmentManager ||
    isUnitManager ||
    isInternationalOfficeUser;

  return {
    isAdmin,
    isDepartmentManager,
    isUnitManager,
    isStudent,
    isInternationalOfficeUser,
    canAccessAdmin,
  };
}
